module.exports = __webpack_public_path__ + "static/media/fasad6.628f8952.jpeg";